export default __webpack_public_path__ + "static/media/fan.8a554c36.svg";